import React from 'react';
import { Alert, Row, Col, Button, Form, Input } from 'antd';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage } from 'react-intl';

import { connect } from 'react-redux';
import { compose } from 'redux';

import { selectIsLoading, selectErrors, selectHasErrors } from 'containers/App/selectors';
import { sendUpdatePassword } from 'containers/App/actions';
import messages from './messages';

class FormPassword extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      submitting: false,
      submitted: false,
      passwords: {
        password: false,
        new_password: false,
        confirm_password: false,
      },
      errors: {
        password: false,
        new_password: false,
        confirm_password: false,
      },
    };
  }

  resetErrors = input => {
    if (typeof input !== 'undefined') {
      this.setState({
        errors: { ...this.state.errors, [input]: false },
      });
    } else {
      this.setState(() => ({
        errors: {
          password: false,
          new_password: false,
          confirm_password: false,
        }
      }));
    }
  };

  isValid() {
    let valid = true;
    const { passwords, errors } = this.state;

    if (
      !passwords.password ||
      passwords.password.trim() === ''
    ) {
      valid = false;
      errors.password = true;
    } else {
      errors.password = false;
    }

    if (
      !passwords.new_password ||
      passwords.new_password.trim() === '' ||
      passwords.new_password.trim().length < 8
    ) {
      valid = false;
      errors.new_password = ['La nuova password deve contenere almeno 8 caratteri'];
    } else {
      errors.new_password = false;
    }

    if (
      passwords.new_password !== passwords.confirm_password
    ) {
      valid = false;
      errors.confirm_password = ['Le due password non coincidono'];
    } else {
      errors.confirm_password = false;
    }

    this.setState(() => ({ errors }));
    return valid;
  }

  handleSubmit = e => {
    e.preventDefault();
    this.resetErrors();

    if (this.isValid()) {
      if (!this.state.submitting) {
        this.props.sendUpdatePassword(this.state.passwords);
        this.setState({ submitting: false, submitted: true });
      }
    }
  };

  onInputChange = e => {
    const value = e.target.value;
    const name = e.target.name;
    this.resetErrors(name);

    this.setState({
      passwords: { ...this.state.passwords, [name]: value },
    });
  };

  onAlertDismiss = () => {
    this.setState({ submitted: false });
  };

  render() {
    let { errors, submitted } = this.state;
    const { hasErrors } = this.props;
    const passwordHasErrors = hasErrors('password')
    errors = { ...errors, ...this.props.updateErrors.password || {} };

    return (
      <div id="PasswordForm" className="mt-4">
        {submitted || passwordHasErrors ?
          <Alert
            showIcon
            closable
            afterClose={this.onAlertDismiss}
            type={passwordHasErrors ? 'error' : 'success'}
            message={passwordHasErrors ? 'Si sono verificati degli errori, controllare i dati inseriti' : 'Aggiornamento avvenuto con successo'}
            className="mb-3"
          />
          : null
        }
        <div className="form-content">
          <Form layout="vertical">
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label="Password attuale"
                  required
                  help={errors.password && (errors.password[0] || 'Questo campo è obbligatorio')}
                  validateStatus={errors.password ? 'error' : null}
                >
                  <Input
                    required
                    type="password"
                    name="password"
                    onChange={this.onInputChange}
                    autoComplete="new-password"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label="Nuova password"
                  required
                  help={errors.new_password && (errors.new_password[0] || 'Questo campo è obbligatorio')}
                  validateStatus={errors.new_password ? 'error' : null}
                >
                  <Input
                    required
                    type="password"
                    name="new_password"
                    onChange={this.onInputChange}
                    autoComplete="new-password"
                    minLength="8"
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Conferma password"
                  required
                  help={errors.confirm_password && (errors.confirm_password[0] || 'Questo campo è obbligatorio')}
                  validateStatus={errors.confirm_password ? 'error' : null}
                >
                  <Input
                    required
                    type="password"
                    name="confirm_password"
                    onChange={this.onInputChange}
                    autoComplete="new-password"
                    minLength="8"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Button
                  type="primary"
                  className="float-right"
                  onClick={this.handleSubmit}
                >
                  <FormattedMessage {...messages.updatePassword} />
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    );
  }
}

export function mapDispatchToProps(dispatch) {
  return {
    sendUpdatePassword: passwords => dispatch(sendUpdatePassword(passwords)),
  };
}

const mapStateToProps = createStructuredSelector({
  isLoading: selectIsLoading(),
  updateErrors: selectErrors(),
  hasErrors: (state, errorDomain) => selectHasErrors(state, errorDomain),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(withConnect)(FormPassword);
